import type { Task } from '@src/features/tasks/types';

export function canEditTaskOnFrontend(
  task: Task,
) {
  return task.canEdit;
}

export function isTaskFieldEditable(task: Task, field: string) {
  return task.editableFields.includes(field);
}
